import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { ESRQuestionConfig } from "../types/data";
import { ESRTextField } from "./questions/ESRTextField";
import { ESRTextBoxField } from "./questions/ESRTextBoxField";
import { ESRBooleanField } from "./questions/ESRBooleanField";
import { ESRBooleanNAField } from "./questions/ESRBooleanNAField";
import { ESRSelectField } from "./questions/ESRSelectField";
import { ESRMultiSelectField } from "./questions/ESRMultiSelectField";
import { ESRSelectOtherField } from "./questions/ESRSelectOtherField";
import { ESRSelectTextField } from "./questions/ESRSelectTextField";
import { ESRMapSelectorField } from "./questions/ESRMapSelector";
import { ESRDateField } from "./questions/ESRDateField";
import { ESRRequestInfoField } from "./questions/ESRRequestInfo";
import { ESRSentResponseField } from "./questions/ESRSentResponse";
import { ESRButtonField } from "./questions/ESRButtonField";
import { ESRLinkField } from "./questions/ESRLinkField";
import { ESRDynamicSelectField } from "./questions/ESRDynamicSelectField";
import { ESRMultiLineTextField } from "./questions/ESRMultiLineTextField";
import { ESRDynamicMultiSelectField } from "./questions/ESRDynamicMultiSelectField";
import { ESRMultiFileUploadField } from "./questions/ESRMultiFileUploadField";
import InfoIcon from "@mui/icons-material/Info";
import { ESRSummaryText } from "./ESRSummaryText";
import { ESRMultiLineTextBox } from "./questions/ESRMultiLineTextBox";

export const ESRPrimitiveField: FC<ESRQuestionConfig> = (props) => {
	switch (props.field_type) {
		case "button":
			return <ESRButtonField {...props}></ESRButtonField>;
		case "bool":
			return <ESRBooleanField {...props}></ESRBooleanField>;
		case "boolNA":
			return <ESRBooleanNAField {...props}></ESRBooleanNAField>;
		case "select":
			return <ESRSelectField {...props}></ESRSelectField>;
		case "multiselect":
			return <ESRMultiSelectField {...props}></ESRMultiSelectField>;
		// Check if these are used *************
		case "dynamicselect":
			return <ESRDynamicSelectField {...props}></ESRDynamicSelectField>;
		case "dynamic_multiselect":
			return (
				<ESRDynamicMultiSelectField {...props}></ESRDynamicMultiSelectField>
			);
		case "selectOther":
			return <ESRSelectOtherField {...props}></ESRSelectOtherField>;
		// *******************************
		case "selectText":
			return <ESRSelectTextField {...props}></ESRSelectTextField>;
		case "text":
			return <ESRTextField {...props}></ESRTextField>;
		case "copy_text":
			return <ESRTextField {...props} copy={true}></ESRTextField>;
		case "expiry_text":
			return <ESRTextField {...props} expiry={true}></ESRTextField>;
		case "multiline_text":
			return <ESRMultiLineTextField {...props}></ESRMultiLineTextField>;
		case "multiline_textbox":
			return <ESRMultiLineTextBox {...props}></ESRMultiLineTextBox>;
		case "textbox":
			return <ESRTextBoxField {...props}></ESRTextBoxField>;
		case "link":
			return <ESRLinkField {...props}></ESRLinkField>;
		case "date":
			return <ESRDateField {...props} mode="date"></ESRDateField>;
		case "year":
			return <ESRDateField {...props} mode="year"></ESRDateField>;
		case "request_info":
			return <ESRRequestInfoField {...props}></ESRRequestInfoField>;
		case "sent_response":
			return <ESRSentResponseField {...props}></ESRSentResponseField>;
		case "file_upload":
			return <ESRMultiFileUploadField {...props}></ESRMultiFileUploadField>;
		case "map":
			return (
				<ESRMapSelectorField {...props} simple={false}></ESRMapSelectorField>
			);
		case "simple_map":
			return (
				<ESRMapSelectorField {...props} simple={true}></ESRMapSelectorField>
			);
		case "summary":
			return <ESRSummaryText {...props}></ESRSummaryText>;
		case "label":
			return (
				<Box display="flex" alignItems="center" gap={1}>
					<InfoIcon color="error" fontSize="small" />
					<Typography variant="body2" color="error">
						{props.field_options[0]}
					</Typography>
				</Box>
			);
		case "simple_header":
			return <></>;
		case "header":
			return <></>;
		default:
			return <Typography>Not yet implemented</Typography>;
	}
};
